import { expression, string, tuple } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isEmptyObject, isObject, isUndefined } from '@philips-internal/oswald-ui-utils';
const hasValue = (value) => (!isUndefined(value) && value !== null && value !== '' && (!isEmptyObject(value) || !isObject(value)));
function prepareMessage(messages) {
    if (messages.length <= 0) {
        return '';
    }
    const requiredEntries = messages.map((message) => MessageService.translate(message)).join(', ');
    return MessageService.translate('tws.validator.required-entries', { requiredEntries });
}
const REQUIRED_ENTRIES = 'required-entries';
function RequiredEntriesValidator(value, { entries = {} } = {}) {
    if (!value) {
        return [{
                message: prepareMessage(Object.values(entries)),
                name: REQUIRED_ENTRIES,
                valid: false,
            }];
    }
    const invalidEntries = [];
    for (const [entryKey, entryMessage] of Object.entries(entries)) {
        const entryValue = value[entryKey];
        if (hasValue(entryValue)) {
            continue;
        }
        invalidEntries.push(entryMessage);
    }
    const valid = invalidEntries.length <= 0;
    return [{
            message: prepareMessage(invalidEntries),
            name: REQUIRED_ENTRIES,
            valid,
        }];
}
RequiredEntriesValidator.optionTypes = {
    entries: tuple([string, expression]),
};
export { REQUIRED_ENTRIES, RequiredEntriesValidator, };
export default RequiredEntriesValidator;
//# sourceMappingURL=required-entries.js.map